import {
  GROUP_DETAIL,
  GROUP_DETAIL_HASMORE,
  UPDATE_GROUP_LIST,
  GROUP_DETAIL_START,
  GROUP_DETAIL_CLEARSTATE,
  UPDATE_GROUP_DETAILS,
  UPDATE_GROUP_DETAIL_BY_ID,
  GROUP_DETAIL_DELETE
} from "../constants/action-types";

const initialState = { group_list: [], hasMore: true, start: 0 };
export default function groupDetailReducer(state = initialState, action) {
  switch (action.type) {
    case GROUP_DETAIL:
      return { ...state, ...action.payload };
    case UPDATE_GROUP_LIST:
      return {
        ...state,
        group_list: [...state.group_list, ...action.payload.group_list]
      };
    case GROUP_DETAIL_HASMORE:
      return { ...state, hasMore: action.payload };
    case GROUP_DETAIL_START:
      return { ...state, start: action.payload };
    case GROUP_DETAIL_CLEARSTATE:
      return initialState;
    case UPDATE_GROUP_DETAILS:
      return {
        ...state,
        ...{
          name: action.payload.name,
          description: action.payload.description,
          group_type_icon: action.payload.group_type_icon,
          group_type_name: action.payload.group_type_name,
          parent_id: action.payload.parent_id
        }
      };

    case UPDATE_GROUP_DETAIL_BY_ID:
      return {
        ...state,
        group_list: state.group_list.map((item, i) =>
          item.id == action.payload.id ? { ...item, ...action.payload } : item
        )
      };
    case GROUP_DETAIL_DELETE:
      let groupList = state.group_list.filter(item => {
        return item.id != action.payload.id;
      });
      return { ...state, group_list: groupList };
    default:
      return state;
  }
}
